import React, { useRef } from "react";
import { Box, Container, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
import { useTranslation } from "react-i18next";
const Com1 = () => {
  const ref = useRef();
  useScrollFadeIn(ref);
  const { t } = useTranslation("whatIsSketch");
  return (
    <Wrapper>
      <Container ref={ref} className="fade-in">
        <div>{t("1-1")}</div>
        <div>{t("1-2")}</div>
        <Box>
          <div>
            <span>{t("1-3")}&nbsp;</span>
            <span>{t("1-4")}</span>
          </div>
        </Box>
      </Container>
    </Wrapper>
  );
};

export default Com1;
